import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";

/**
 * Stand-in for pages still to be ported off the CodeIgniter pre-owned admin.
 * Exists so the mode switch and theming can be exercised end-to-end.
 */
export function PreownedPlaceholderPage({ title = "Pre-Owned" }) {
  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Paper>
        <Box p={3}>
          <Typography variant="body2" color="textSecondary">
            Not yet ported from the CodeIgniter pre-owned admin.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}

export const PreownedTwsSyncPage = () => (
  <PreownedPlaceholderPage title="Sync with TWS" />
);

export default PreownedPlaceholderPage;